import { Stack, TextField as MUITextField, MenuItem } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';

import FieldLabel from './FieldLabel';

function SelectField({
  label,
  tooltip,
  control,
  name,
  rules,
  disabled,
  items = [],
}) {
  return (
    <Stack spacing={1}>
      <FieldLabel label={label} tooltip={tooltip} />
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <MUITextField select disabled={disabled} {...field}>
            {items.map((i) => (
              <MenuItem key={i.key} value={i.value}>
                {i.label}
              </MenuItem>
            ))}
          </MUITextField>
        )}
      />
    </Stack>
  );
}

export default SelectField;
